<template>
    <div class="control-label-container">
        <label
            :for="control.uniqueId"
            :class="[control.additionalLabelClass, readOnly ? 'bold' : '']"
        >{{ localizedLabel }}<span v-if="showRequiredMarker" class="required-marker" aria-hidden="true">*</span></label>
        <br v-if="localizedSubLabel" />
        <small
            v-if="localizedSubLabel"
            v-text="localizedSubLabel"
        />
    </div>
</template>

<script>
    import { getLocalizedField } from "../../../utils/languageHelper";

    export default {
        name: "ControlLabel",
        props: {
            control: {
                type: Object,
                required: true
            },
            readOnly: {
                type: Boolean,
                default: false,
            },
            language: {
                type: String,
                default: 'en'
            },
            viewSubmissionMode: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            localizedLabel() {
                return getLocalizedField(this.control, 'label', this.language);
            },
            localizedSubLabel() {
                return getLocalizedField(this.control, 'subLabel', this.language);
            },
            /** True when the control carries a `required` validation rule. */
            isRequired() {
                const rules = Array.isArray(this.control && this.control.validations) ? this.control.validations : []
                return rules.some(r => r && String(r.ruleType || '').toLowerCase() === 'required')
            },
            /**
             * Patient-fill and builder canvas only. ViewSubmission (staff review) and
             * ViewSubmissionForPDF (Puppeteer PDF) both set viewSubmissionMode=true and must render
             * exactly as before; read-only renders show the label bold with no marker.
             */
            showRequiredMarker() {
                return this.isRequired && !this.readOnly && !this.viewSubmissionMode
            }
        }
    }
</script>

<style scoped>
label.bold {
  font-weight: 600;
}

.required-marker {
  color: #dc3545;
  margin-left: 2px;
  font-weight: 700;
}
</style>
